{
  "label": "管理後台",
  "nav": {
    "dashboard": "總覽",
    "newAssignment": "新增作業",
    "instances": "所有 Brev 機器",
    "settings": "設定",
    "devTools": "開發工具",
    "devStates": "候選人狀態",
    "devAdminPreview": "後台預覽",
    "devEmails": "郵件",
    "signedInAs": "登入身分",
    "openMenu": "開啟導覽",
    "closeMenu": "關閉導覽",
    "build": "版本",
    "timezone": "時區",
    "developmentBuild": "開發中",
    "devOverview": "功能預覽"
  },
  "role": {
    "owner": "擁有者",
    "admin": "管理員"
  },
  "gate": {
    "signInTitle": "請透過 Cloudflare Access 登入",
    "signInBody": "管理後台受 Cloudflare Access 保護，請使用 Google Workspace 帳號登入。",
    "reload": "登入",
    "notAdminTitle": "此帳號不是管理員",
    "notAdminBody": "請擁有者在「設定 → 管理員」新增您的帳號。",
    "errorTitle": "無法載入管理後台"
  },
  "banner": {
    "brevCredential": "需要重新登入 Brev：儲存的 NVIDIA 會話已無法更新。請依 runbook「Rotate Brev credential」處理。",
    "unmanaged": "有 {{count}} 台執行中的 Brev 機器不受 作業平台 管理，請到「所有 Brev 機器」確認。",
    "unmanaged_other": "有 {{count}} 台執行中的 Brev 機器不受 作業平台 管理，請到「所有 Brev 機器」確認。"
  },
  "status": {
    "draft": "草稿",
    "link_issued": "已發連結",
    "active": "進行中",
    "finished": "已完成",
    "expired": "已過期",
    "revoked": "已撤銷",
    "archived": "已封存",
    "not_started": "尚未開始"
  },
  "endReason": {
    "finished": "候選人結束",
    "budget_exhausted": "GPU 時數用完",
    "window_expired": "作業時間限制已到期",
    "revoked": "管理員撤銷",
    "session_expired": "連續作答時間已到期",
    "deadline_expired": "已到固定截止時間"
  },
  "dashboard": {
    "title": "總覽",
    "tiles": {
      "runningNow": "執行中",
      "active": "進行中的作業",
      "gpuHours": "本月 GPU 時數",
      "spend": "本月預估花費",
      "spendOf": "每位候選人軟性預算 {{budget}}",
      "failures": "錯誤"
    },
    "table": {
      "candidate": "候選人",
      "email": "Email",
      "state": "狀態",
      "gpu": "GPU 時間",
      "windowEnd": "期限",
      "spend": "花費",
      "lastActivity": "最後活動",
      "noInstance": "尚無機器",
      "notLaunched": "尚未啟動"
    },
    "filters": {
      "all": "全部"
    },
    "search": "搜尋姓名、Email、標題",
    "empty": "尚無作業。",
    "emptyHint": "建立第一個作業，為候選人準備機器。",
    "maxReached": "已有兩個進行中的作業。請先結束或撤銷一個，或到設定調高上限。",
    "refreshed": "更新於 <timestamp/>"
  },
  "wizard": {
    "title": "新增作業",
    "steps": {
      "candidate": "候選人",
      "brief": "題目",
      "limits": "限制",
      "gpu": "GPU",
      "review": "確認",
      "kind": "類型",
      "ai": "AI 輔助"
    },
    "stepOf": "第 {{n}} 步，共 {{total}} 步",
    "candidate": {
      "email": "候選人 Email",
      "emailHelp": "登入驗證碼會寄到此信箱。邀請連結由 HR 另行寄送。",
      "name": "候選人姓名",
      "title": "作業標題",
      "titleHelp": "顯示在候選人頁面標頭，例如「Isaac Sim 作業」。",
      "notes": "內部備註",
      "notesHelp": "僅管理員可見，候選人看不到。"
    },
    "brief": {
      "url": "題目說明連結（Notion）",
      "help": "候選人會看到「作業說明」按鈕。若由 HR 寄送，可留空。",
      "none": "沒有題目連結"
    },
    "limits": {
      "budgetHours": "GPU 時數上限（小時）",
      "budgetHelp": "= {{minutes}} 分鐘。只在 GPU 執行時計算。",
      "windowDays": "作業視窗（自第一次 Launch 起的天數）",
      "windowHelp": "期限到後，無論剩餘時數，連結與 session 都會結束。",
      "inviteDays": "邀請連結有效天數",
      "inviteHelp": "自複製連結給 HR 起算；重新產生連結時重新計算。",
      "sessionMinutes": "連續作答時間（分鐘，選填）",
      "sessionHelp": "從本次作答首次啟動開始計時，暫停機器不會停止計時。留空表示不限。",
      "deadlineAt": "固定截止時間（選填）",
      "deadlineHelp": "使用 {{timezone}} 時區。此截止時間在測驗開始前也適用；留空表示不啟用。",
      "earliest": "測驗期間或已啟用的截止限制，以最先到期者結束存取。暫停僅停止 GPU 用量計時。",
      "none": "未啟用",
      "preview": "若現在啟動，存取將於 <timestamp/> 結束。",
      "invitationGroup": "測驗開始前",
      "workGroup": "作答時間",
      "optionalGroup": "額外截止限制（選填）",
      "writtenEarliest": "測驗期間或已啟用的截止限制，以最先到期者結束存取。離開頁面不會暫停計時。",
      "writtenPreview": "若現在開啟，存取將於 <timestamp/> 結束。"
    },
    "gpu": {
      "type": "GPU",
      "perHour": "US${{rate}}/小時",
      "l40sDesc": "預設。48 GB VRAM、RT 核心。AWS g6e.4xlarge。",
      "a10gDesc": "較便宜。24 GB VRAM、RT 核心，大型場景較吃緊。",
      "disk": "磁碟（GB）",
      "diskHelp": "暫停時保留；機器存在期間會計儲存費。",
      "region": "主機區域",
      "regionHelp": "選擇「任何區域」時，由 Brev 挑選有空閒 GPU 的區域與可用區，與 Brev launchable 相同。只有在需要時才指定 AWS 區域；GPU 供應情況依區域而異。",
      "anyRegion": "任何區域（由 Brev 選擇有容量的區域）",
      "machine": "機器規格：{{machine}}",
      "pricingCatalog": "此機型與區域的 Brev 目錄估價。不指定區域時，價格可能依實際配置區域而異；儲存費另計。實際費用以 Brev 計費用量為準。",
      "pricingFallback": "目前無法取得此機型與區域的 Brev 報價，顯示設定的備用估價；這不代表機型有可用容量。"
    },
    "review": {
      "title": "確認",
      "hint": "按下「建立機器」會呼叫 Brev 建立 GPU 工作區（啟動後才開始計費）。",
      "estimate": "此額度的 GPU 費用估計約 US${{usd}}"
    },
    "create": "建立機器",
    "creating": "建立中…",
    "created": "機器已建立，請依清單完成準備。",
    "next": "下一步",
    "back": "上一步",
    "errors": {
      "max_active_reached": "已有兩個進行中的作業。請先結束或撤銷一個，或到設定調高上限。",
      "candidate_exists": "此 Email 的候選人已有作業。",
      "brev_error": "Brev 拒絕了此請求，請查看錯誤內容後重試。",
      "continuous_session_disabled": "管理員已停用連續作答時限。請重新載入建立流程以使用最新設定。"
    },
    "kind": "作業類型",
    "kinds": {
      "isaac_sim": {
        "title": "Isaac Sim 居家作業",
        "description": "包含 VS Code 與 Isaac Sim 檢視器的 GPU 工作區。"
      },
      "gpu_vscode": {
        "title": "GPU 程式開發居家作業",
        "description": "使用 VS Code 進行程式開發的 GPU 工作區，不含模擬檢視器。"
      },
      "free_response": {
        "title": "書面居家作業",
        "description": "在瀏覽器閱讀 Markdown 題目並提交書面答案，不使用 GPU。"
      }
    }
  },
  "detail": {
    "title": "作業",
    "backToDashboard": "總覽",
    "endedReason": "已結束：{{reason}}",
    "checklist": {
      "title": "準備清單",
      "hint": "系統會自動完成準備。可先將邀請連結交給 HR；Isaac Sim 就緒後，候選人即可啟動。",
      "created": "機器已建立",
      "started": "GPU 已自動啟動",
      "startedHint": "建立後會自動啟動 GPU 並準備工作區。",
      "warmup": "自動預熱完成",
      "warmupHint": "Isaac Sim 會自動啟動並建立著色器快取。串流應用程式載入完成後，系統會確認就緒。預熱完成只會通知管理員。",
      "autoPause": "自動暫停或候選人啟動",
      "stopHint": "工作區 持續就緒 3 分鐘後，GPU 會自動暫停；若候選人先啟動則繼續執行。暫停後可按 Launch 恢復工作區；準備期間不扣候選人的 GPU 時間。",
      "linkIssued": "邀請連結已產生",
      "linkIssuedHint": "建立作業時自動產生，隨時可於上方複製。預熱完成後候選人即可開始作答。",
      "markWarmup": "標記預熱已確認",
      "copyLink": "產生邀請連結",
      "regenerate": "重新產生連結",
      "issuedBy": "由 {{by}} 發出 · <timestamp/>",
      "linkExpires": "連結有效至 <timestamp/>",
      "doneBy": "{{by}} · <timestamp/>",
      "gpuHint": "系統會自動準備工作區，完成後候選人即可啟動。",
      "workspace": "工作區已驗證",
      "workspaceHint": "系統自動檢查 VS Code 是否就緒。請開啟 VS Code 驗證工作區。",
      "complete": "準備完成"
    },
    "inviteDialog": {
      "title": "給 HR 的邀請連結",
      "body": "連結會持續顯示於此，可隨時複製連結或下方邀請文字。候選人仍需驗證電子郵件，預熱完成後才能開始作答。",
      "link": "邀請連結",
      "text": "給 HR 貼上的文字",
      "copyText": "複製文字",
      "legacy": "舊連結僅儲存雜湊，仍可使用但無法還原。請使用下方「重新產生連結」替換一次，新連結就會持續顯示於此。",
      "message": {
        "intro": "您好，這是 {{kind}} 作業的登入連結：{{url}}",
        "linkExpiry": "· 邀請連結有效 {{days}} 天，至 {{expiry}}。",
        "writtenWindow": "· 第一次開啟題目後，作業視窗為 {{days}} 天。",
        "gpuWindow": "· 第一次按下 Launch 後，作業視窗為 {{days}} 天。",
        "activeWindow": "· 截止時間：{{deadline}}。作業期限已開始，不會因再次進入而重設。",
        "writtenInstructions": "· 請在瀏覽器中閱讀題目、撰寫 Markdown 答案並提交。",
        "gpuBudget": "· GPU 時間共 {{hours}} 小時，只有機器執行時才計算；不用時請按 Pause。",
        "gpuRemaining": "· GPU 剩餘時間：{{remaining}}（時:分:秒，截至 {{asOf}}）。最新剩餘時間請以工作區為準；不用時請暫停。",
        "sessionLimit": "· 連續作答時間上限：從本次作答開始起 {{minutes}} 分鐘；離開頁面後仍會繼續計時。",
        "fixedDeadline": "· 固定截止時間：{{deadline}}。",
        "writtenCutoff": "· 作業視窗、連續作答時間或固定截止時間中最早到期者，將結束編輯權限。",
        "gpuCutoff": "· 作業視窗、連續作答時間、固定截止時間或 GPU 時間額度中最早到期者，將結束使用權限。",
        "reply": "有任何問題請直接回覆這封信。"
      },
      "writtenBody": "連結會持續顯示於此，可複製連結或下方雙語文字給 HR。候選人驗證電子郵件並完成同意程序後，即可開啟題目。"
    },
    "regenerateDialog": {
      "title": "要重新產生邀請連結嗎？",
      "body": "舊連結立即失效，有效期重新計算。請把新連結交給 HR。"
    },
    "countdowns": {
      "title": "候選人看到的資訊",
      "gpuLeft": "GPU 剩餘時間",
      "deadline": "截止時間",
      "deadlineNotStarted": "第一次 Launch 起 {{days}} 天",
      "grace": "寬限結束",
      "used": "已用 {{used}}，共 {{budget}}",
      "gpuPaused": "暫停"
    },
    "instance": {
      "pendingCreation": "工作區仍在準備或確認建立結果。若設定失敗，請排除錯誤後重試建立；作業平台 會先確認是否已有機器，避免重複建立。",
      "region": "區域",
      "title": "機器",
      "none": "尚未附加機器。",
      "brevId": "Brev 工作區",
      "name": "名稱",
      "type": "GPU",
      "ip": "公開 IP",
      "dns": "DNS",
      "brevStatus": "Brev 狀態",
      "health": "健康狀態",
      "lastSynced": "最後同步",
      "lastError": "最後錯誤",
      "vscodePassword": "VS Code 密碼",
      "viewerAuth": "檢視器登入",
      "openVscode": "開啟 VS Code",
      "openViewer": "開啟檢視器",
      "noIp": "尚無公開 IP",
      "build": "建置進度",
      "createdAt": "建立於 <timestamp/>"
    },
    "buildProgress": {
      "vmBuild": "虛擬機建置",
      "script": "設定腳本",
      "recovered": "先前的設定曾失敗；之後已確認就緒。",
      "history": "先前的設定紀錄",
      "attemptEnded": "該次設定結束於"
    },
    "actions": {
      "title": "操作",
      "start": "啟動",
      "stop": "暫停",
      "reset": "重設",
      "delete": "刪除機器",
      "extendBudget": "延長時數",
      "extendWindow": "延長期限",
      "revoke": "撤銷",
      "markFinished": "標記為完成",
      "retryCreate": "重試建立",
      "working": "處理中…",
      "reopen": "重新開放作業",
      "changeRegion": "變更區域",
      "editLimits": "編輯時間限制"
    },
    "dialogs": {
      "stopTitle": "要暫停機器嗎？",
      "stopBody": "GPU 停止，費用只剩儲存。工作區的檔案會保留。",
      "resetTitle": "要重設機器嗎？",
      "resetBody": "Brev 會重新開機。機器不健康時使用。",
      "deleteTitle": "刪除機器",
      "deleteBody": "會刪除 Brev 工作區與其中所有內容，候選人的工作會遺失。請輸入下方顯示的候選人 Email 確認。",
      "deleteConfirmLabel": "候選人 Email",
      "deleteEmailUnavailable": "候選人 Email 不可用，無法確認刪除。",
      "extendBudgetTitle": "延長 GPU 時數",
      "extendBudgetBody": "為候選人增加時數，並取消進行中的寬限期。候選人首次登入後，若設定已啟用通知，便會收到通知信。",
      "extendBudgetField": "增加小時數",
      "extendWindowTitle": "延長期限",
      "extendWindowBody": "增加作業視窗天數；若連結已過期會重新啟用。候選人首次登入後，若設定已啟用通知，便會收到通知信。",
      "extendWindowField": "增加天數",
      "revokeTitle": "要撤銷此作業嗎？",
      "revokeBody": "機器停止、所有 session 結束、邀請連結失效。候選人無法再登入。",
      "finishTitle": "要標記為完成嗎？",
      "finishBody": "等同候選人按下 Finish：GPU 停止，作業鎖定。",
      "startBody": "啟動 GPU。執行期間會計費。",
      "changeRegionTitle": "在其他區域建立",
      "changeRegionBody": "會刪除無法啟動的工作區，並在所選區域重新建立。邀請連結、GPU 時數與作業視窗維持不變。僅限機器從未執行過時使用。",
      "changeRegionField": "新區域",
      "changeRegionCurrent": "目前區域：{{region}}",
      "changeRegionSuccess": "正在 {{region}} 建立工作區"
    },
    "tabs": {
      "audit": "稽核記錄",
      "segments": "執行區段",
      "sessions": "Session",
      "emails": "郵件",
      "consent": "同意記錄",
      "feedback": "使用回饋"
    },
    "audit": {
      "at": "時間",
      "actor": "操作者",
      "action": "動作",
      "result": "結果",
      "brev": "Brev",
      "detail": "細節",
      "empty": "尚無操作記錄。"
    },
    "segments": {
      "start": "開始",
      "stop": "停止",
      "duration": "時長",
      "rate": "費率",
      "cost": "費用",
      "by": "啟動／停止者",
      "total": "GPU 計費總時間",
      "running": "執行中",
      "empty": "GPU 尚未執行過。",
      "candidate": "候選人 GPU 使用時間",
      "admin": "準備／啟動／待機（不扣候選人額度）",
      "category": "時間類別",
      "startup": "工作區 啟動／未就緒（不扣候選人額度）",
      "metered": "Brev 本月計費",
      "meteredBreakdown": "GPU {{compute}} · 磁碟 {{storage}} · 計費 {{rate}}/小時",
      "meteredNoRate": "GPU {{compute}} · 磁碟 {{storage}}"
    },
    "sessions": {
      "created": "建立",
      "lastSeen": "最後活動",
      "expires": "到期",
      "ip": "IP",
      "agent": "瀏覽器",
      "revoke": "撤銷",
      "revoked": "已撤銷",
      "empty": "沒有 session。"
    },
    "emails": {
      "at": "寄出",
      "to": "收件人",
      "template": "範本",
      "subject": "主旨",
      "status": "狀態",
      "empty": "尚未寄出郵件。",
      "statuses": {
        "queued": "排程中",
        "sent": "已寄送",
        "failed": "失敗",
        "logged": "僅記錄",
        "suppressed": "已於設定停用"
      }
    },
    "consent": {
      "version": "同意書版本",
      "accepted": "同意時間",
      "ip": "IP",
      "agent": "瀏覽器",
      "empty": "候選人尚未同意隱私協議。"
    },
    "candidate": {
      "title": "候選人",
      "notes": "備註",
      "edit": "編輯",
      "editTitle": "編輯作業",
      "saved": "已儲存"
    },
    "spend": {
      "title": "花費",
      "computeOf": "GPU {{compute}}，軟性預算 {{budget}}",
      "rate": "{{rate}}/小時",
      "diskEstimated": "磁碟費用為預估值，下次 Brev 同步後更新",
      "diskDetail": "停機 {{stopped}} · {{amount}}",
      "legend": {
        "candidate": "候選人 GPU 時間",
        "admin": "準備／管理員 GPU 時間",
        "disk": "磁碟（整個生命週期，執行或停機）"
      }
    },
    "reopen": {
      "body": "設定新的 GPU 剩餘額度與從現在開始的新期限。保留過往用量與檔案，機器必須已停止。請將新的邀請連結提供給候選人；舊連結與登入將失效。系統不會自動寄信。",
      "hours": "新的 GPU 剩餘時數",
      "days": "新期限（從現在起算天數）",
      "success": "作業已重新開放。請複製並分享新的邀請連結。"
    },
    "feedback": {
      "hint": "候選人對作業流程的選填回饋，將隨作業資料於 90 天保留期限後刪除。",
      "empty": "尚無回饋。",
      "loading": "正在載入回饋…",
      "error": "無法載入回饋。",
      "retry": "再試一次"
    },
    "limits": {
      "confirmExpiry": "若新限制已到期，允許此次變更立即結束存取權限。"
    },
    "reviewTitle": "內容審閱與活動紀錄"
  },
  "instances": {
    "title": "所有 Brev 機器",
    "hint": "Brev 組織內的全部工作區，包含不受 作業平台 管理的機器。",
    "fetchedAt": "擷取於 <timestamp/>",
    "managed": "受管理",
    "unmanaged": "未受管理",
    "cols": {
      "name": "名稱",
      "status": "狀態",
      "type": "類型",
      "ip": "IP",
      "created": "建立",
      "candidate": "候選人",
      "metered": "Brev 計費（本月）"
    },
    "stop": "停止",
    "stopAll": "停止所有執行中",
    "stopAllTitle": "要停止所有執行中的機器嗎？",
    "stopAllBody": "將停止 {{count}} 台執行中的工作區，包含未受管理的機器。候選人會失去執行中的 session（檔案保留）。請輸入 STOP 確認。",
    "stopAllConfirm": "STOP",
    "stopped": "已停止 {{count}} 台機器",
    "stopOne": "要停止「{{name}}」嗎？",
    "empty": "Brev 組織內沒有工作區。",
    "refresh": "重新整理",
    "meteredSummary": "Brev 本月計費至今：{{total}}",
    "meteredSyncedAt": "同步於 <timestamp/>",
    "meteredNever": "尚未同步 Brev 計費用量。每小時自動同步；可按「同步用量」立即擷取。",
    "syncUsage": "同步用量",
    "synced": "已同步 Brev 用量：{{count}} 個工作區，本月 {{total}}",
    "syncFailed": "無法擷取 Brev 用量",
    "meteredCompute": "GPU {{amount}}",
    "meteredStorage": "磁碟 {{amount}}/天",
    "meteredRate": "計費 {{rate}}/小時"
  },
  "settings": {
    "workspace": {
      "title": "安全工作區存取",
      "hint": "啟用後，新建工作區會自動準備安全存取。既有工作區仍須明確選擇設定；關閉此功能只影響新的設定作業。",
      "enabled": "自動為新建工作區準備安全存取"
    },
    "autoPause": {
      "title": "GPU 自動暫停",
      "enabled": "管理員手動啟動後自動暫停",
      "hint": "關閉後，管理員手動啟動的工作區會在準備期間持續執行，直到暫停或候選人啟動作業。首次自動預熱仍會在 Isaac Sim 持續就緒 3 分鐘後暫停。候選人啟動後，仍適用 GPU 時數與作業期限規則。"
    },
    "title": "設定",
    "readOnly": "您可以變更自己的郵件語言；系統設定由擁有者管理。",
    "saved": "設定已儲存",
    "admins": {
      "title": "管理員",
      "hint": "管理員透過 Cloudflare Access 登入，且必須列在此處。",
      "email": "Email",
      "name": "姓名",
      "add": "新增管理員",
      "remove": "移除",
      "removeTitle": "要移除 {{email}} 嗎？",
      "removeBody": "對方會立即失去管理後台的存取權。",
      "addedBy": "由 {{by}} 新增",
      "ownerLocked": "擁有者無法被移除。",
      "emailLanguage": "郵件語言"
    },
    "rates": {
      "title": "GPU 備用估算費率（美元／小時）",
      "hint": "新工作區會自動採用 Brev 對應機型與區域的目錄估價。僅在無法取得報價時使用下方備用值。既有工作區費率快照不變；實際費用以 Brev 計費用量為準。"
    },
    "limits": {
      "title": "限制",
      "otpAttempts": "驗證碼錯誤次數上限",
      "otpAttemptsHint": "每個邀請連結允許的驗證碼錯誤次數（1–20）。達到上限後會停用邀請，必須由 HR 產生新連結；重新寄送驗證碼不會重設次數。",
      "maxActive": "同時進行中的作業上限",
      "costBudget": "每位候選人的軟性預算（US$）",
      "costHint": "80 % 與 100 % 時發出警示，不會阻擋。"
    },
    "defaults": {
      "title": "新作業預設值",
      "gpu": "GPU",
      "disk": "磁碟（GB）",
      "budget": "GPU 時數上限（分鐘）",
      "window": "視窗（天）",
      "invite": "邀請有效期（天）",
      "resume": "顯示給候選人的恢復時間預估（最少、最多分鐘）",
      "gpuVscodeDisk": "GPU + VS Code 磁碟（GB）",
      "continuousSession": "啟用連續作答時間限制",
      "continuousSessionHint": "允許新作業設定連續作答時間限制。既有作業維持原本的限制。",
      "diskHint": "Isaac Sim 與 GPU + VS Code 作業共用的預設磁碟容量。"
    },
    "agreement": {
      "title": "隱私協議",
      "version": "協議版本",
      "warning": "更改版本後，所有候選人下次進入時必須重新同意。請先更新 docs/privacy-agreement.md。"
    },
    "alerts": {
      "title": "警示收件人",
      "hint": "管理員郵件（花費、錯誤、憑證、每日摘要）會寄到這裡。",
      "add": "新增 Email",
      "placeholder": "name@example.com"
    },
    "tests": {
      "title": "連線測試",
      "brev": "測試 Brev 連線",
      "email": "寄送測試郵件",
      "emailTo": "寄到",
      "ok": "正常",
      "failed": "失敗",
      "latency": "{{ms}} 毫秒"
    },
    "danger": {
      "title": "危險區",
      "body": "刪除機器與撤銷作業在各作業頁面進行，需輸入名稱確認。「停止所有執行中」在「所有 Brev 機器」頁。"
    },
    "notifications": {
      "candidate": "候選人郵件",
      "admin": "管理員郵件",
      "candidateHint": "候選人首次登入後才會收到作業通知。預熱完成只會通知管理員。就緒通知也會遵守候選人的「通知我」選項。",
      "adminHint": "寄送至下方通知收件人；清單空白時寄給擁有者。",
      "hint": "儲存後套用於未來事件。重新開啟不會補寄已略過的郵件，也不會變更計時或機器操作。",
      "signinRequired": "登入驗證碼固定開啟，確保候選人可以登入。",
      "templates": {
        "instance_ready": "Isaac Sim 預熱完成",
        "budget_5h": "GPU 時數剩餘 5 小時",
        "budget_3h": "GPU 時數剩餘 3 小時",
        "budget_1h": "GPU 時數剩餘 1 小時",
        "budget_0h": "GPU 時數已用完",
        "window_5h": "作答期限剩餘 5 小時",
        "window_3h": "作答期限剩餘 3 小時",
        "window_1h": "作答期限剩餘 1 小時",
        "session_closed": "工作階段已結束",
        "extended": "GPU 時數或作答期限已延長",
        "admin_first_launch": "候選人首次啟動",
        "admin_instance_ready": "Isaac Sim 預熱完成",
        "admin_finished": "候選人完成作答",
        "admin_instance_failure": "機器發生錯誤",
        "admin_spend": "費用達到通知門檻",
        "admin_credential_failure": "Brev 憑證健康檢查失敗",
        "admin_digest": "每日摘要",
        "admin_brev_login_required": "需要重新登入 Brev"
      }
    }
  },
  "workspaceFailure": {
    "activationFailed": "無法啟用安全存取。排除問題後，請選擇「重試驗證」以檢查連線並啟用存取。",
    "certificatePending": "安全連線憑證尚未就緒。請稍候幾分鐘，再選擇「重試驗證」。",
    "certificateVerificationFailed": "無法驗證安全連線憑證。這可能是暫時性的問題；請稍候幾分鐘，再選擇「重試驗證」。",
    "connectorNotReady": "工作區連線尚未就緒。請等待設定完成，並確認主機正在執行，再選擇「重試驗證」。",
    "setupFailed": "安全存取設定未能完成。請依診斷代碼排除問題，再重試設定。",
    "retryVerify": "重試驗證",
    "diagnostic": "診斷代碼："
  },
  "preview": {
    "title": "後台預覽",
    "hint": "目前安全存取流程，含範例作業收件人與獨立郵件語言。預覽操作不會變更實際作業。",
    "dashboard": "總覽",
    "assignment": "作業",
    "state": "機器狀態",
    "localAction": "預覽：{{action}}",
    "aiPrompt": "如何驗證抓取規劃器在部分遮擋情況下的表現？",
    "aiReply": "使用**模擬遮擋情境**，測量抓取成功率與碰撞次數，再與視野清晰時的基準比較。"
  },
  "misc": {
    "hoursOf": "{{used}} / {{budget}} 小時",
    "na": "—",
    "usd": "US${{n}}",
    "confirmTyped": "輸入「{{word}}」以確認",
    "unknownError": "發生錯誤。"
  },
  "notifications": {
    "title": "作業通知",
    "description": "設定此作業的通知收件人。系統通知使用全域收件人清單。",
    "edit": "編輯收件人",
    "recipients": "通知收件人",
    "recipientsHelp": "每行輸入一個 Email，或以逗號分隔。所有收件人均使用管理員信件語言。",
    "candidateEmailLocale": "候選人信件語言",
    "adminEmailLocale": "管理員信件語言",
    "defaultRecipient": "此作業預設通知你。建立後，你或系統擁有者可新增收件人。",
    "saved": "已儲存通知設定",
    "englishDefault": "English（預設）",
    "perPerson": "已註冊管理員依個人設定的語言收信；未註冊的收件人預設收到英文郵件。",
    "manageLanguages": "管理個人郵件語言",
    "ownerOnly": "僅作業建立者或系統擁有者可編輯收件人。",
    "editCandidateLanguage": "編輯郵件語言",
    "owner": "負責人"
  },
  "emailPreview": {
    "title": "電子郵件設計",
    "hint": "使用範例資料預覽所有實際寄送的範本，不會寄出任何信件。候選人語言依作業設定；管理員語言依個人帳號設定，未註冊收件人預設使用英文。",
    "guide": "設計規範",
    "source": "預覽來源",
    "designs": "範本設計",
    "log": "寄送紀錄",
    "template": "郵件範本",
    "candidate": "候選人",
    "admin": "管理員",
    "signin": "登入驗證碼",
    "language": "郵件語言",
    "width": "預覽寬度",
    "desktop": "桌面",
    "mobile": "手機 · 320 px",
    "format": "訊息格式",
    "html": "郵件版面",
    "text": "純文字",
    "error": "無法載入郵件預覽，請重新整理或確認管理員權限。",
    "subject": "主旨",
    "frame": "郵件預覽",
    "empty": "尚無寄送紀錄。可使用「範本設計」查看郵件，不必實際寄信。"
  },
  "answer": {
    "title": "答案",
    "loading": "載入答案中…",
    "error": "無法載入答案。",
    "attempt": "作答階段／提交快照",
    "current": "目前第 {{attempt}} 次作答 · 修訂 {{revision}}",
    "submission": "第 {{attempt}} 次作答已提交 · {{time}}",
    "copy": "複製 Markdown",
    "export": "匯出 .md",
    "revisionHint": "修訂編號代表儲存次數，不保留每次自動儲存的歷史草稿。已提交的作答為不可變更快照。",
    "empty": "尚未儲存答案。",
    "question": "題目 · 版本 {{version}}",
    "editQuestion": "編輯題目",
    "questionMarkdown": "題目（Markdown）",
    "questionHelp": "請撰寫作業題目，不顯示圖片或嵌入式 HTML，上限 200 KB。",
    "force": "我了解候選人已開啟題目。發布新版本後，候選人須確認草稿與新題目。",
    "editError": "無法更新題目，請確認是否需要強制更新。",
    "notOpened": "尚未開啟",
    "reopen": "立即建立新作答階段與期限。先前提交仍為唯讀，舊邀請與工作階段將失效。",
    "questionStep": "題目",
    "windowDays": "期限（從首次開啟起算的天數）",
    "sessionHelp": "從開啟本次作答起計時，留空表示不限。",
    "createHint": "建立時儲存題目並產生邀請，不配置機器。候選人同意條款後開啟作答時才開始計時。",
    "create": "建立作答",
    "inviteText": "您的書面作答邀請：{{url}}\n邀請有效 {{inviteDays}} 天，首次開啟後有 {{windowDays}} 天作答時間，仍受較早到期的連續作答時間或固定期限限制。請在瀏覽器閱讀題目、撰寫 Markdown 答案並提交，不需要 GPU。",
    "snapshotQuestionUnavailable": "這份歷史提交的題目快照目前無法使用。",
    "created": "測驗已建立，準備好後即可分享邀請連結。"
  },
  "ai": {
    "title": "AI 對話",
    "liveUnavailable": "此環境尚未啟用正式 AI，或缺少伺服器憑證。",
    "enabled": "為此測驗啟用 AI",
    "models": "可用模型",
    "noModels": "目前沒有可用的相容模型，請至設定更新模型目錄。",
    "defaultModel": "預設模型",
    "limit": "初始 AI 額度（美元）",
    "policy": "助理指引",
    "policyHint": "指引可影響回覆，但無法保證模型行為。目前不提供工具或自動分享答案功能。",
    "toolsOff": "內建聊天不會執行工具或自動分享答案。OpenCode 支援工作區工具與 Exa 網頁搜尋。供應商憑證僅留在伺服器。",
    "retryCatalog": "重試載入模型目錄",
    "loading": "載入 AI 資料中…",
    "error": "AI 操作失敗。請重新整理資料後再試。",
    "browser": "對話",
    "requests": "請求",
    "config": "用量與設定",
    "captureNotice": "審查存取與匯出均會留下稽核紀錄。答案草稿不會自動傳給 AI。",
    "conversation": "對話",
    "attempt": "第 {{n}} 次測驗",
    "more": "載入更多",
    "older": "載入較早訊息",
    "empty": "尚無對話紀錄。",
    "exportJson": "匯出此頁審查資料（JSON）",
    "exportMarkdown": "匯出此頁審查資料（Markdown）",
    "exportHint": "匯出包含最新一頁對話，以及各對話最新一頁訊息。請使用上方分頁功能審查更早紀錄；JSON 提供後續頁面游標。",
    "partial": "目前未啟用 OpenCode 提示詞記錄。請求中繼資料僅涵蓋受管理的代理；私人金鑰與其他端點不在紀錄範圍內。",
    "requestUsage": "輸入 {{input}} · 輸出 {{output}} · {{cost}}",
    "save": "儲存 AI 設定",
    "additional": "增加額度（美元）",
    "addBudget": "增加 AI 額度",
    "budgetAdded": "AI 額度已更新。",
    "globalTitle": "AI 預設設定",
    "provider": "AI 供應商",
    "providerOff": "停用",
    "refresh": "更新模型目錄",
    "stale": "模型目錄可能已過期，選取模型前請先更新。",
    "initial": "AI 輔助",
    "off": "預設停用",
    "liveEnabled": "測試環境已啟用正式 AI。",
    "mockEnabled": "本機模擬 AI 已啟用，回覆與用量均為模擬資料。",
    "allZdrModels": "候選人可選擇 OpenRouter 目前 ZDR 目錄中任何相容的文字聊天模型；供應商可用性與價格可能不同。",
    "requireByok": "強制使用 BYOK",
    "requireByokHint": "關閉：可使用已設定的 BYOK 或 OpenRouter 額度。開啟：只允許已確認的 BYOK-only 供應商路由，其他模型將拒絕請求；此開關不會修改 OpenRouter 帳戶設定。",
    "catalogUnavailable": "無法更新模型目錄。已儲存的預設模型維持不變，請再試一次更新目錄。",
    "summary": {
      "title": "AI 用量",
      "enabled": "此作業已啟用 AI",
      "disabled": "此作業未啟用 AI",
      "pending": "費用核算中",
      "used": "已使用",
      "budget": "預算",
      "remaining": "剩餘",
      "unknown": "核算中",
      "lessThan": "< {{amount}}",
      "progress": "AI 預算使用量",
      "progressValue": "已使用 {{used}}，預算 {{budget}}",
      "pendingHint": "目前顯示最新已知用量，供應商帳單仍在核算中。",
      "providerUpdated": "供應商資料確認於 <timestamp/>",
      "stale": "無法更新用量，目前顯示上次取得的數值。",
      "mock": "此環境顯示模擬用量。",
      "unavailable": "已設定 AI，但此環境目前無法使用。",
      "providerRecorded": "供應商已記錄用量",
      "lastActivity": "最近請求活動",
      "noActivity": "尚無活動記錄"
    },
    "recordWorkspaceChat": "記錄受管理的 OpenCode 對話",
    "recordingHelp": "依現有保留政策儲存候選人提示詞與可見回覆，供授權的作業審查者檢視。候選人須先同意錄製告知，才能使用受管理的 OpenCode。",
    "recordingLocked": "此作業在本次作答開始前未啟用對話記錄，因此無法在作答進行中啟用。",
    "sources": {
      "browser": "內建對話",
      "opencode": "OpenCode"
    },
    "workspaceCaptureScope": "此為透過受管理的 OpenCode 傳送之候選人提示詞與可見回覆的部分紀錄。不包含內部推理、工具輸出，以及使用私人金鑰或其他端點的請求。",
    "partialRecorded": "已啟用受管理的 OpenCode 提示詞記錄。提示詞與可見回覆可於「對話」檢視，此處列出請求中繼資料。紀錄範圍有限，不包含私人金鑰與其他端點。"
  }
}
